import React, { memo, useState } from 'react';
import { Tabs } from 'antd';
import styled from '@emotion/styled';
import { Typography } from '~/UI';
import Page from '~/router/Page';
import LookerEmbed from './LookerEmbed';
import { theme } from '~/utils';
import { useFlags } from '~/utils/launchdarkly';

const LOOKS_IDS = {
  MODULE_PRICING_BY_CATEGORY: 'module_pricing_by_category',
  MODULE_PERCENTILE_PRICING: 'module_percentile_pricing',
  MODULE_PRICING_ABOVE_BELOW_SIMILAR: 'module_pricing_above_below_similar',
};

const StyledTabs = styled(Tabs)`
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${theme.colors.primary};
  }
  .ant-tabs-ink-bar {
    background: ${theme.colors
      .primary} !important; // Set your desired active underline color
  }
  .ant-tabs-tab:hover {
    color: ${theme.colors.primary};
  }
`;

const MarketIntelligence: React.FC = () => {
  const { solarSupplierProductIntelligence } = useFlags();
  const [renderModulePercentile, setRenderModulePercentile] = useState(false);
  const [
    renderModulePricingAboveBelowSimilar,
    setRenderModulePricingAboveBelowSimilar,
  ] = useState(false);

  return (
    <Page title="Dashboard">
      <div style={{ paddingLeft: '16px', marginBottom: '16px' }}>
        <Typography.VendorSectionHeader
          style={{
            marginBottom: '12px',
          }}
        >
          Market Intelligence
        </Typography.VendorSectionHeader>
      </div>
      <StyledTabs
        items={[
          {
            key: 'pricing_trends',
            label: 'Pricing Trends',
            children: (
              <>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    alignItems: 'stretch',
                    gap: '12px',
                  }}
                >
                  <LookerEmbed
                    style={{
                      flexGrow: '1',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      border: '1px solid #E2E8F0',
                    }}
                    id={LOOKS_IDS.MODULE_PRICING_BY_CATEGORY}
                    onLoad={() => setRenderModulePercentile(true)}
                  />
                  {renderModulePercentile && (
                    <LookerEmbed
                      style={{
                        flexGrow: '1',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        border: '1px solid #E2E8F0',
                      }}
                      id={LOOKS_IDS.MODULE_PERCENTILE_PRICING}
                      onLoad={() =>
                        setRenderModulePricingAboveBelowSimilar(true)
                      }
                    />
                  )}
                </div>
                {renderModulePricingAboveBelowSimilar && (
                  <LookerEmbed
                    style={{
                      marginTop: '12px',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      border: '1px solid #E2E8F0',
                    }}
                    id={LOOKS_IDS.MODULE_PRICING_ABOVE_BELOW_SIMILAR}
                  />
                )}
              </>
            ),
          },
          ...(solarSupplierProductIntelligence
            ? [
                {
                  key: 'product_intelligence',
                  label: 'Product Intelligence',
                  children: <></>,
                },
              ]
            : []),
        ]}
      />
    </Page>
  );
};

export default memo(MarketIntelligence);
